import { useUserLanguage } from '@/customHooks'
import styled from 'styled-components'

type StatusPillProps = {
  isActive?: boolean
}

const textsData = {
  en: {
    active: 'Active',
    inactive: 'Inactive',
  },
  es: {
    active: 'Activo',
    inactive: 'Inactivo',
  }
}

const PillContainer = styled.div<{ $isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: bold;
  color: ${(props) => (props.$isActive ? '#4a9462' : '#ff7878')};
  background-color: ${(props) => (props.$isActive ? '#d2f3dc' : '#ffd7d7')};
`;

export const StatusPill = ({ isActive }: StatusPillProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en
  return (
    <PillContainer $isActive={!!isActive}>
      {isActive ? texts.active : texts.inactive}
    </PillContainer>
  );
}